import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "capitalize" })
export class Capitalize implements PipeTransform {
	transform(value: string): string {
		return value[0]?.toUpperCase() + value?.slice(1);
	}
}
